

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface BuildingParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface Building {
    id?: number;
    tenantId: any;
    branchId: any;
  
    name:string; 
    
  parameters?: BuildingParameter[];
  links?: any;
}

export abstract class BuildingData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(url: string): Observable<Building[]>;
  abstract create(url: string, data: Building): Observable<Building[]>;
  abstract update(url: string, data: Building): Observable<Building>;
  abstract delete(url: string): Observable<any>;
 
}
